import { render, staticRenderFns } from "./LocalizedNumeric.vue?vue&type=template&id=dbae05fc&"
import script from "./LocalizedNumeric.vue?vue&type=script&lang=js&"
export * from "./LocalizedNumeric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports